export interface DialogMessages {
  requirePredecessor: string;
  eiIdAlreadyExistsServiceProvider: string;
  eiIdAlreadyExistsNotServiceProvider: string;
  saveAsDraft: string;
  deleteDraftTitle: string;
  deleteWarning: string;
  unsavedDataWarning: string;
}

export const EI_DIALOG_MESSAGES: DialogMessages = {
  requirePredecessor:
    'This document is a required predecessor for other attached documents. Are you sure you want to delete?',
  eiIdAlreadyExistsServiceProvider:
    'A child with that Child EI ID already exists at your agency. Please confirm the Child EI ID. If the Child EI ID is correct, please go back and select that child from the dashboard grid. If you do not see the child on your list, reach out to your Agency Administrator to upload the document.',
  eiIdAlreadyExistsNotServiceProvider:
    'A child with that Child EI ID already exists in system. Please confirm the Child EI ID. If the Child EI ID is correct, please recheck the dashboard for this child to upload documents.',
  saveAsDraft:
    'The form is successfully saved in draft mode, and it will be available for 30 days for editing . The form can be edited from the Dashboard.',
  deleteDraftTitle: 'Delete Draft',
  deleteWarning:
    'This will delete the draft record and all associated files. Are you sure you want to proceed with deletion?',
  unsavedDataWarning:
    'All the unsaved data and documents will be lost. Are you sure want to cancel the request?',
};
